// import { useEffect, useState } from "react";
// import { getNonApprovalPOs } from "../../utils/api";
// import { formatDate } from "../User/components/UserEditPO";
// import { BeatLoader } from "react-spinners";
// import { useDispatch, useSelector } from "react-redux";
// import { IoEyeOutline } from "react-icons/io5";
// import { approveOrderAsync, type Order } from "../../store/Slice/orderSlice";
// import { toast } from "react-toastify";
// import { selectLoggedInUser } from "../../store/Slice/authSlice";

// const SubadminApprovePO = () => {
//   const [orders, setOrders] = useState<any[]>([]);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const limit = 10;
//   const [loading, setLoading] = useState(false);
//   const [activeCard, setActiveCard] = useState<
//     "total" | "half" | "r&d" | "production"
//   >("total");
//   const [counts, setCounts] = useState({
//     total: 0,
//     halfApproved: 0,
//     rAndD: 0,
//     production: 0,
//   });




//   const loggedInUser = useSelector(selectLoggedInUser);
//   const userDepartment = loggedInUser?.department?.toLowerCase();
//   const dispatch = useDispatch();

//   // VIEW modal state
//   const [viewModalOpen, setViewModalOpen] = useState(false);
//   const [viewOrder, setViewOrder] = useState<Order | null>(null);



//   const isRnD = userDepartment === "r&d";
//   const isProduction = userDepartment === "production";

//   const handleViewDetails = (order: any) => {
//     setViewOrder(order);
//     setViewModalOpen(true);
//   };

//   const handlePrev = () => setPage((prev) => Math.max(prev - 1, 1));
//   const handleNext = () => setPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageClick = (num: number) => setPage(num);

//   const handleApprove = async (orderId: string) => {
//     const res = await dispatch(approveOrderAsync(orderId) as any);

//     if (res.meta.requestStatus === "fulfilled") {
//       toast.success("Order approved successfully");
//       setOrders((prev) =>
//         prev.map((o) =>
//           o._id === orderId
//             ? {
//               ...o,
//               approval: {
//                 ...o.approval,
//                 rAndD: isRnD ? true : o.approval?.rAndD,
//                 production: isProduction ? true : o.approval?.production,
//                 finalApproved:
//                   (isRnD ? true : o.approval?.rAndD) &&
//                   (isProduction ? true : o.approval?.production),
//               },
//             }
//             : o
//         )
//       );
//     } else {
//       toast.error(res.payload || "Approval failed");
//     }
//   };

//   const getProgressPercent = (approval: any) => {
//     let percent = 0;
//     if (approval?.rAndD) percent += 50;
//     if (approval?.production) percent += 50;
//     return percent;
//   };

//   const canUserApprove = (order: any) => {
//     if (isRnD && !order.approval?.rAndD) return true;
//     if (isProduction && !order.approval?.production) return true;
//     return false;
//   };

//   const ProgressBar = ({ approval }: { approval: any }) => {
//     const width = "100px"; // fixed width same as approve button
//     const percent = getProgressPercent(approval);
//     const label =
//       approval?.finalApproved
//         ? "✅ 100% Approved"
//         : approval?.rAndD
//           ? "✅ R&D "
//           : approval?.production
//             ? "✅ Production"
//             : "Pending";
//     return (
//       <div
//         className="bg-gray-200 rounded-full h-8 flex items-center justify-center text-xs font-semibold text-black relative"
//         style={{ width }}
//         title={label}
//       >
//         <div
//           className={`absolute left-0 top-0 h-8 rounded-full ${percent === 100 ? "bg-green-600" : "bg-yellow-500"}`}
//           style={{ width: `${percent}%` }}
//         />
//         <span className="relative z-10">{label}</span>
//       </div>
//     );
//   };

//   const getApproveButtonClass = (order: any) => {
//     const isHalfApproved =
//       order.approval?.rAndD === true || order.approval?.production === true;

//     if (isHalfApproved) {
//       return "bg-green-600 hover:bg-green-700";
//     }

//     return "bg-blue-600 hover:bg-blue-700";
//   };

//   // 🔹 Filter orders based on activeCard
// const filteredOrders = orders.filter((order) => {
//   if (activeCard === "total") return true;
//   if (activeCard === "half") {

//     return (
//       (order.approval?.rAndD && !order.approval?.production) ||
//       (!order.approval?.rAndD && order.approval?.production)
//     );
//   }
//   if (activeCard === "r&d") return order.approval?.rAndD;
//   if (activeCard === "production") return order.approval?.production;
//   return true;
// });


//   useEffect(() => {
//     const loadOrders = async () => {
//       setLoading(true);
//       try {
//         const { orders, pagination, counts } = await getNonApprovalPOs(page, limit);
//         setOrders(orders);
//         setCounts(counts)
//         setTotalPages(pagination.totalPages);
//       } catch (error) {
//         console.log(error, "Error fetching orders");
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadOrders();
//   }, [page]);

//   return (
//     <div className="flex flex-col gap-6 justify-start items-center w-full">
//       <h1 className="text-2xl font-bold">PO Approvals</h1>

//       <div className="w-full flex justify-between items-center gap-3 flex-wrap">
//         {/* CARDS */}
//         <div className="w-full flex justify-between items-center ">
//           {/* Total POs */}
//           <div
//             onClick={() => setActiveCard("total")}
//             className={`cursor-pointer px-4 py-2 rounded-md border text-sm font-semibold
//         ${activeCard === "total"
//                 ? "bg-gray-800 text-white"
//                 : "bg-white dark:bg-zinc-900"}
//       `}
//           >
//            Total POs: {counts.total}
//           </div>

//           {/* Half Approved */}
//           <div
//             onClick={() => setActiveCard("half")}
//             className={`cursor-pointer px-4 py-2 rounded-md border text-sm font-semibold
//     ${activeCard === "half"
//                 ? "bg-yellow-500 text-white"
//                 : "bg-white dark:bg-zinc-900"}
//   `}
//           >
//            Half Approved: {counts.halfApproved}
//           </div>


//           {/* R&D Approved */}
//           <div
//             onClick={() => setActiveCard("r&d")}
//             className={`cursor-pointer px-4 py-2 rounded-md border text-sm font-semibold
//         ${activeCard === "r&d"
//                 ? "bg-blue-600 text-white"
//                 : "bg-white dark:bg-zinc-900"}
//       `}
//           >
//           Approved by R&D: {counts.rAndD}
//           </div>

//           {/* Production Approved */}
//           <div
//             onClick={() => setActiveCard("production")}
//             className={`cursor-pointer px-4 py-2 rounded-md border text-sm font-semibold
//         ${activeCard === "production"
//                 ? "bg-purple-600 text-white"
//                 : "bg-white dark:bg-zinc-900"}
//       `}
//           >
//            Approved by Production: {counts.production}
//           </div>
//         </div>
//       </div>



//       {
//         loading ? (
//           <BeatLoader />
//         ) : (
//           <>
//             {/* Desktop Table */}
//             <div className="w-full hidden lg:table">
//               <table className="w-full mb-6">
//                 <thead className="bg-gray-200 text-black font-bold">
//                   <tr className="bg-white dark:bg-zinc-900 dark:text-white">
//                     <td className="py-2 uppercase text-start px-2">Order Number</td>
//                     <td className="py-2 uppercase text-center px-2">Generated By</td>
//                     <td className="py-2 uppercase text-center px-2">Creation Date</td>
//                     <td className="py-2 uppercase text-center px-2">Dispatch Date</td>
//                     <td className="py-2 uppercase text-center px-2">Status</td>
//                     <td className="py-2 uppercase text-end px-12">Action</td>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredOrders.map((order: any, index: number) => (
//                     <tr
//                       key={index}
//                       className="odd:bg-gray-100 even:bg-white dark:odd:bg-zinc-800 dark:even:bg-zinc-900 hover:bg-gray-200"
//                     >
//                       <td className="py-2 text-start px-2 text-blue-500 font-semibold">
//                         {order.orderNumber}
//                       </td>
//                       <td className="py-2 text-center px-2 capitalize font-bold flex flex-col">
//                         <span>{order.generatedBy.username}</span>
//                         <span className="text-xs font-light">{order.generatedBy.employeeId}</span>
//                       </td>
//                       <td className="py-2 text-center px-2 font-semibold text-gray-600 dark:text-white">
//                         {order.orderDate ? formatDate(order.orderDate) : formatDate(order.createdAt)}
//                       </td>
//                       <td className="text-center font-semibold text-gray-600 dark:text-white">
//                         {order.estimatedDispatchDate?.split("T")[0]}
//                       </td>
//                       <td className="py-2 text-center px-2">
//                         <span
//                           className={`font-semibold uppercase text-xs tracking-wider rounded-full px-2 py-1
//                           ${order.status === "completed" && "bg-green-100 text-green-600"}
//                           ${order.status === "pending" && "bg-yellow-100 text-yellow-600"}
//                           ${order.status === "delayed" && "bg-orange-100 text-orange-600"}
//                           ${order.status === "rejected" && "bg-red-100 text-red-600"}
//                         `}
//                         >
//                           {order.status}
//                         </span>
//                       </td>
//                       <td className="py-2 text-end px-2 flex justify-end items-center gap-3">
//                         <IoEyeOutline
//                           onClick={() => handleViewDetails(order)}
//                           className="hover:bg-blue-800 p-1 rounded-sm hover:text-white duration-200 cursor-pointer text-2xl"
//                         />

//                         {canUserApprove(order) ? (
//                           <button
//                             onClick={() => handleApprove(order._id)}
//                             className={`${getApproveButtonClass(order)} text-white px-3 py-1 rounded transition`}
//                             style={{ width: "100px" }}
//                             title={
//                               order.approval?.rAndD && isProduction
//                                 ? "R&D has already approved"
//                                 : order.approval?.production && isRnD
//                                   ? "Production has already approved"
//                                   : "Click to approve"
//                             }
//                           >
//                             Approve
//                           </button>

//                         ) : (
//                           <ProgressBar approval={order.approval} />
//                         )}


//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Mobile Cards */}
//             <div className="w-full flex flex-col gap-4 lg:hidden">
//               {filteredOrders.map((order: any, index: number) => (
//                 <div
//                   key={index}
//                   className="bg-white dark:bg-zinc-800 shadow-md rounded-lg p-4 flex flex-col gap-2"
//                 >
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Order Number:</span>
//                     <span className="text-end text-blue-500 font-semibold">{order.orderNumber}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Generated By:</span>
//                     <span className="text-end capitalize font-bold">{order.generatedBy.username}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Creation Date:</span>
//                     <span className="text-end font-semibold text-gray-600 dark:text-white">
//                       {order.orderDate ? formatDate(order.orderDate) : formatDate(order.createdAt)}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Status:</span>
//                     <span
//                       className={`font-semibold uppercase text-xs tracking-wider rounded-full px-2 py-1
//                         ${order.status === "completed" && "bg-green-100 text-green-600"}
//                         ${order.status === "pending" && "bg-yellow-100 text-yellow-600"}
//                         ${order.status === "delayed" && "bg-orange-100 text-orange-600"}
//                         ${order.status === "rejected" && "bg-red-100 text-red-600"}
//                       `}
//                     >
//                       {order.status}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="font-semibold">Dispatch Date:</span>
//                     <span className="text-end font-semibold text-gray-600 dark:text-white">
//                       {order.estimatedDispatchDate?.split("T")[0]}
//                     </span>
//                   </div>
//                   <div className="flex justify-end items-center gap-2">
//                     <IoEyeOutline
//                       onClick={() => handleViewDetails(order)}
//                       className="hover:bg-blue-800 p-1 rounded-sm hover:text-white duration-200 cursor-pointer text-2xl"
//                     />

//                     {canUserApprove(order) ? (
//                       <button
//                         onClick={() => handleApprove(order._id)}
//                         className={`${getApproveButtonClass(order)} text-white px-3 py-1 rounded transition`}
//                         style={{ width: "100px" }}
//                         title={
//                           order.approval?.rAndD && isProduction
//                             ? "R&D has already approved"
//                             : order.approval?.production && isRnD
//                               ? "Production has already approved"
//                               : "Click to approve"
//                         }
//                       >
//                         Approve
//                       </button>

//                     ) : (
//                       <ProgressBar approval={order.approval} />
//                     )}


//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Pagination */}
//             <div className="flex justify-center items-center gap-2 pb-10">
//               <button
//                 onClick={handlePrev}
//                 disabled={page === 1}
//                 className="px-3 py-1 bg-gray-300 dark:bg-zinc-900 disabled:opacity-50 rounded"
//               >
//                 Prev
//               </button>
//               {Array.from({ length: totalPages }, (_, idx) => idx + 1)
//                 .filter((p) => p === 1 || p === totalPages || (p >= page - 1 && p <= page + 1))
//                 .map((p, i, arr) => {
//                   const prevPage = arr[i - 1];
//                   return (
//                     <span key={p} className="flex items-center gap-2">
//                       {prevPage && p - prevPage > 1 && <span className="px-2">...</span>}
//                       <button
//                         onClick={() => handlePageClick(p)}
//                         className={`px-3 py-1 rounded ${page === p ? "bg-blue-500 text-white" : "bg-gray-200 dark:bg-zinc-900"}`}
//                       >
//                         {p}
//                       </button>
//                     </span>
//                   );
//                 })}
//               <button
//                 onClick={handleNext}
//                 disabled={page === totalPages}
//                 className="px-3 py-1 bg-gray-300 dark:bg-zinc-900 disabled:opacity-50 rounded"
//               >
//                 Next
//               </button>
//             </div>
//           </>
//         )
//       }

//       {/* View Details Modal */}
//       {
//         viewModalOpen && viewOrder && (
//           <div className="fixed inset-0 flex items-center justify-center p-4 bg-black/40 z-50">
//             <div className="bg-white dark:bg-zinc-800 text-black dark:text-white p-6 rounded-lg shadow-lg w-full max-w-3xl overflow-auto max-h-[90vh]">
//               <div className="flex justify-between items-start mb-4">
//                 <h2 className="text-xl font-bold">PO Details</h2>
//                 <button
//                   onClick={() => {
//                     setViewModalOpen(false);
//                     setViewOrder(null);
//                   }}
//                   className="text-xl font-bold px-2 py-1 rounded hover:bg-gray-200 dark:hover:bg-zinc-700"
//                   aria-label="Close details"
//                 >
//                   &times;
//                 </button>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <p>
//                     <strong>Order Number:</strong> {viewOrder.orderNumber}
//                   </p>
//                   <p>
//                     <strong>Generated By:</strong> {viewOrder.generatedBy?.username}
//                   </p>
//                   <p>
//                     <strong>Employee ID:</strong> {viewOrder.generatedBy?.employeeId}
//                   </p>
//                   <p>
//                     <strong>Status:</strong>{" "}
//                     <span className="uppercase font-semibold">{viewOrder.status}</span>
//                   </p>
//                 </div>
//                 <div>
//                   <p>
//                     <strong>Order Date:</strong> {formatDate(viewOrder.orderDate || viewOrder.createdAt)}
//                   </p>
//                   <p>
//                     <strong>Dispatch Date:</strong>{" "}
//                     {viewOrder.estimatedDispatchDate ? viewOrder.estimatedDispatchDate.split("T")[0] : "N/A"}
//                   </p>
//                   <p>
//                     <strong>Contact:</strong> {viewOrder.contact || "N/A"}
//                   </p>
//                   <p>
//                     <strong>Company:</strong> {viewOrder.companyName || "N/A"}
//                   </p>
//                 </div>
//               </div>

//               {viewOrder.products && viewOrder.products.length > 0 && (
//                 <>
//                   <h3 className="mt-4 font-bold">Products</h3>
//                   <div className="mt-2 border rounded">
//                     <table className="w-full text-sm">
//                       <thead className="bg-gray-100 text-left">
//                         <tr>
//                           <th className="px-3 py-2">Name</th>
//                           <th className="px-3 py-2">Qty</th>
//                           <th className="px-3 py-2">Price</th>
//                           <th className="px-3 py-2">Remark</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewOrder.products.map((p: any, i: number) => (
//                           <tr key={i} className="border-t">
//                             <td className="px-3 py-2">{p.name}</td>
//                             <td className="px-3 py-2">{p.quantity}</td>
//                             <td className="px-3 py-2">{p.price}</td>
//                             <td className="px-3 py-2">{p.remark || "-"}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}

//               <div className="flex justify-end mt-4">
//                 <button
//                   onClick={() => {
//                     setViewModalOpen(false);
//                     setViewOrder(null);
//                   }}
//                   className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )
//       }
//     </div >
//   );
// };

// export default SubadminApprovePO;


import { useEffect, useState } from "react";
import { getNonApprovalPOs } from "../../utils/api";
import { formatDate } from "../User/components/UserEditPO";
import { BeatLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { IoEyeOutline, IoCloseCircle } from "react-icons/io5";
import { approveOrderAsync, type Order } from "../../store/Slice/orderSlice";
import { toast } from "react-toastify";
import { selectLoggedInUser } from "../../store/Slice/authSlice";

const SubadminApprovePO = () => {
  const [orders, setOrders] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const [loading, setLoading] = useState(false);
  const [activeCard, setActiveCard] = useState<
    "total" | "r&d" | "production"
  >("total");
  const [counts, setCounts] = useState({
    total: 0,
    rAndD: 0,
    production: 0,
  });

  // NEW: Click-based details card
  const [selectedOrder, setSelectedOrder] = useState<string | null>(null);
  const [approvingOrders, setApprovingOrders] = useState<Set<string>>(new Set());

  const loggedInUser = useSelector(selectLoggedInUser);
  const userDepartment = loggedInUser?.department?.toLowerCase();
  const dispatch = useDispatch();

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewOrder, setViewOrder] = useState<Order | null>(null);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [approveOrder, setApproveOrder] = useState<Order | null>(null);
  const [approveType, setApproveType] = useState<"all" | "quantity">("all");
  const [quantities, setQuantities] = useState<Record<number, number>>({});

  const isRnD = userDepartment === "r&d";
  const isProduction = userDepartment === "production";

  const handleViewDetails = (order: any) => {
    setViewOrder(order);
    setViewModalOpen(true);
  };

  const handlePrev = () => setPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () => setPage((prev) => Math.min(prev + 1, totalPages));
  const handlePageClick = (num: number) => setPage(num);

  // const handleApprove = async (orderId: string) => {
  //   setApprovingOrders(prev => new Set(prev).add(orderId));

  //   const res = await dispatch(approveOrderAsync(orderId) as any);

  //   if (res.meta.requestStatus === "fulfilled") {
  //     toast.success("Order approved successfully");

  //     // 1️⃣ Update local state (ALWAYS use OBJECT, never boolean)
  //     setOrders(prev =>
  //       prev.map(o => {
  //         if (o._id !== orderId) return o;

  //         const rApproved =
  //           isRnD ? true : o.approval?.rAndD?.approved === true;
  //         const pApproved =
  //           isProduction ? true : o.approval?.production?.approved === true;

  //         return {
  //           ...o,
  //           approval: {
  //             ...o.approval,
  //             rAndD: isRnD
  //               ? {
  //                 approved: true,
  //                 approvedBy: { username: loggedInUser.username },
  //                 approvedAt: new Date().toISOString(),
  //               }
  //               : o.approval?.rAndD,

  //             production: isProduction
  //               ? {
  //                 approved: true,
  //                 approvedBy: { username: loggedInUser.username },
  //                 approvedAt: new Date().toISOString(),
  //               }
  //               : o.approval?.production,

  //             finalApproved: rApproved && pApproved,
  //           },
  //         };
  //       })
  //     );

  //     // 2️⃣ Remove from list ONLY if both approvals are true
  //     setTimeout(() => {
  //       setOrders(prev =>
  //         prev.filter(o => {
  //           if (o._id !== orderId) return true;

  //           const rApproved = o.approval?.rAndD?.approved === true;
  //           const pApproved = o.approval?.production?.approved === true;

  //           return !(rApproved && pApproved);
  //         })
  //       );

  //       setApprovingOrders(prev => {
  //         const newSet = new Set(prev);
  //         newSet.delete(orderId);
  //         return newSet;
  //       });
  //     }, 800);
  //   } else {
  //     toast.error(res.payload || "Approval failed");
  //     setApprovingOrders(prev => {
  //       const newSet = new Set(prev);
  //       newSet.delete(orderId);
  //       return newSet;
  //     });
  //   }
  // };

  const handleApprove = (order: any) => {

    setApproveOrder(order);
    setApproveModalOpen(true);

    const initialQty: Record<number, number> = {};

    order.products?.forEach((p: any, i: number) => {
      initialQty[i] = 0;
    });

    setQuantities(initialQty);
    setApproveType("all");

  };

  const formatDateTime = (date: string) => {
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const canUserApprove = (order: any) => {

    if (!order.products) return false;

    return order.products.some((p: any) => {

      const rdApproved = p.approvedQuantity?.rAndD || 0;
      const prodApproved = p.approvedQuantity?.production || 0;

      if (isRnD) {
        return rdApproved < p.quantity;
      }

      if (isProduction) {
        return prodApproved < p.quantity;
      }

      return false;

    });

  };

  const confirmApprove = async () => {

    if (!approveOrder || !approveOrder._id) {
      toast.error("Order ID missing");
      return;
    }

    const orderId = approveOrder._id;

    setApprovingOrders(prev => new Set(prev).add(orderId));

    const payload =
      approveType === "all"
        ? { type: "all" }
        : { type: "quantity", quantities };

    const res = await dispatch(
      approveOrderAsync({
        orderId,
        payload,
      }) as any
    );

    if (res.meta.requestStatus === "fulfilled") {

      toast.success("Order approved successfully");

      setOrders(prev =>
        (prev || [])
          .map(o => (o?._id === orderId ? res?.payload?.order || o : o))
          .filter(Boolean)
      );



      setSelectedOrder(null);

      setApproveModalOpen(false);
      setApproveOrder(null);
      setQuantities({});
    } else {
      toast.error(res.payload || "Approval failed");
    }

    setApprovingOrders(prev => {
      const newSet = new Set(prev);
      newSet.delete(orderId);
      return newSet;
    });

  };

  const filteredOrders = (orders || [])
    .filter((order) => order && order._id)
    .filter((order) => {

      const rApproved = order?.approval?.rAndD?.approved === true;
      const pApproved = order?.approval?.production?.approved === true;

      if (activeCard === "total") return true;
      if (activeCard === "r&d") return rApproved;
      if (activeCard === "production") return pApproved;

      return true;
    });

  useEffect(() => {
    if (selectedOrder && !orders.find(o => o?._id === selectedOrder)) {
      setSelectedOrder(null);
    }
  }, [orders]);

  useEffect(() => {
    const loadOrders = async () => {
      setLoading(true);
      try {
        const { orders, pagination, counts } = await getNonApprovalPOs(page, limit);
        setOrders(orders);
        setCounts(counts);
        setTotalPages(pagination.totalPages);
      } catch (error) {
        console.log(error, "Error fetching orders");
      } finally {
        setLoading(false);
      }
    };
    loadOrders();
  }, [page]);

  // Progress bar click handler
  const handleProgressClick = (order: any) => {

    if (!canUserApprove(order)) return;
    setApproveOrder(order);
    setApproveModalOpen(true);

    const initialQty: Record<number, number> = {};

    order.products?.forEach((p: any, i: number) => {
      initialQty[i] = 0;
    });

    setQuantities(initialQty);
    setApproveType("all");

  };

  // Get progress percentage
  const getProgressPercentage = (order: any) => {

    if (!order.products) return 0;

    let totalQty = 0;
    let approvedQty = 0;

    order.products.forEach((p: any) => {

      totalQty += (p.quantity || 0) * 2;

      approvedQty += p?.approvedQuantity?.rAndD ?? 0;
      approvedQty += p?.approvedQuantity?.production ?? 0;

    });

    if (totalQty === 0) return 0;

    return Math.round((approvedQty / totalQty) * 100);
  };


  return (
    <div className="flex flex-col gap-6 justify-start items-center w-full min-h-screen p-4 md:p-6 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-zinc-950 dark:via-slate-900 dark:to-indigo-950">
      {/* Header */}
      <div className="w-full text-center mb-4 animate-fade-in">
        <h1 className="text-4xl md:text-5xl font-black bg-[#0A2975] bg-clip-text text-transparent drop-shadow-lg">
          PO Approvals Dashboard
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-3 text-lg font-medium">Manage and track purchase order approvals</p>
      </div>

      {/* Filter Cards */}
      <div className="w-full max-w-6xl mx-auto mb-6">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div
            onClick={() => setActiveCard("total")}
            className={`cursor-pointer rounded-2xl px-6 py-6 text-center transition-all duration-300 transform hover:scale-105 hover:-rotate-1
              ${activeCard === "total"
                ? "bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900 text-white shadow-2xl ring-4 ring-slate-500/50"
                : "bg-white dark:bg-zinc-900 border-2 border-gray-200 dark:border-zinc-700 hover:shadow-2xl hover:border-slate-400"
              }`}
          >
            <p className="text-xs opacity-70 mb-2 uppercase tracking-wider font-semibold">Total POs</p>
            <p className="text-3xl font-black">{counts.total}</p>
          </div>


          <div
            onClick={() => setActiveCard("r&d")}
            className={`cursor-pointer rounded-2xl px-6 py-6 text-center transition-all duration-300 transform hover:scale-105 hover:-rotate-1
              ${activeCard === "r&d"
                ? "bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900 text-white shadow-2xl ring-4 ring-slate-500/50"
                : "bg-white dark:bg-zinc-900 border-2 border-gray-200 dark:border-zinc-700 hover:shadow-2xl hover:border-slate-400"
              }`}
          >
            <p className="text-xs opacity-70 mb-2 uppercase tracking-wider font-semibold">R&D Approved</p>
            <p className="text-3xl font-black">{counts.rAndD}</p>
          </div>

          <div
            onClick={() => setActiveCard("production")}
            className={`cursor-pointer rounded-2xl px-6 py-6 text-center transition-all duration-300 transform hover:scale-105 hover:rotate-1
              ${activeCard === "production"
                ? "bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900 text-white shadow-2xl ring-4 ring-slate-500/50"
                : "bg-white dark:bg-zinc-900 border-2 border-gray-200 dark:border-zinc-700 hover:shadow-2xl hover:border-slate-400"
              }`}
          >
            <p className="text-xs opacity-70 mb-2 uppercase tracking-wider font-semibold">Production</p>
            <p className="text-3xl font-black">{counts.production}</p>
          </div>
        </div>

        {/* Click-based Details Card */}
        {selectedOrder && (() => {
          const order = orders.find(o => o._id === selectedOrder);
          return order ? (
            <div className="mt-6 p-6 bg-gradient-to-br from-white via-blue-50 to-purple-50 dark:from-zinc-900 dark:via-blue-950/30 dark:to-purple-950/30 rounded-2xl border-2 border-blue-300 dark:border-blue-700 shadow-2xl animate-slide-down backdrop-blur-sm">

              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-2 h-12 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
                  <div>
                    <span className="text-2xl font-black text-blue-600 dark:text-blue-400">
                      {order.orderNumber}
                    </span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">
                      Detailed Approval Status
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => setSelectedOrder(null)}
                  className="p-2 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-xl transition-all duration-200 group"
                >
                  <IoCloseCircle className="text-3xl text-red-500 dark:text-red-400 group-hover:scale-110 transition-transform" />
                </button>
              </div>

              {/* ================= DEPARTMENTS ================= */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* R&D */}
                <div className="bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/40 dark:to-indigo-900/40 p-5 rounded-xl border-2 border-blue-300 dark:border-blue-700 shadow-lg">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-bold text-blue-900 dark:text-blue-200">
                      R&D Department
                    </span>

                    {order.approval?.rAndD?.approved ? (
                      <div className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full shadow-md">
                        ✓ <span className="font-bold text-sm">Approved</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 bg-gray-400 dark:bg-gray-600 text-white px-4 py-2 rounded-full shadow-md">
                        ⏳ <span className="font-bold text-sm">Pending</span>
                      </div>
                    )}
                  </div>

                  <div className="text-sm text-gray-700 dark:text-gray-300">
                    <p className="font-semibold">
                      Status:
                      <span
                        className={
                          order.approval?.rAndD?.approved
                            ? "text-green-600 ml-1"
                            : "text-amber-600 ml-1"
                        }
                      >
                        {order.approval?.rAndD?.approved
                          ? "Completed"
                          : "Awaiting Review"}
                      </span>
                    </p>

                    {order.approval?.rAndD?.approved && (
                      <div className="mt-2 text-xs space-y-1">
                        <p>
                          <span className="font-semibold">Approved By:</span>{" "}
                          {order.approval.rAndD.approvedBy?.username || "-"}
                        </p>
                        <p>
                          <span className="font-semibold">Approved At:</span>{" "}
                          {formatDateTime(order.approval.rAndD.approvedAt)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Production */}
                <div className="bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-900/40 dark:to-pink-900/40 p-5 rounded-xl border-2 border-purple-300 dark:border-purple-700 shadow-lg">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-bold text-purple-900 dark:text-purple-200">
                      Production Department
                    </span>

                    {order.approval?.production?.approved ? (
                      <div className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full shadow-md">
                        ✓ <span className="font-bold text-sm">Approved</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 bg-gray-400 dark:bg-gray-600 text-white px-4 py-2 rounded-full shadow-md">
                        ⏳ <span className="font-bold text-sm">Pending</span>
                      </div>
                    )}
                  </div>

                  <div className="text-sm text-gray-700 dark:text-gray-300">
                    <p className="font-semibold">
                      Status:
                      <span
                        className={
                          order.approval?.production?.approved
                            ? "text-green-600 ml-1"
                            : "text-amber-600 ml-1"
                        }
                      >
                        {order.approval?.production?.approved
                          ? "Completed"
                          : "Awaiting Review"}
                      </span>
                    </p>

                    {order.approval?.production?.approved && (
                      <div className="mt-2 text-xs space-y-1">
                        <p>
                          <span className="font-semibold">Approved By:</span>{" "}
                          {order.approval.production.approvedBy?.username || "-"}
                        </p>
                        <p>
                          <span className="font-semibold">Approved At:</span>{" "}
                          {formatDateTime(order.approval.production.approvedAt)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ================= PRODUCTS ================= */}
              <div className="mt-6">
                <h3 className="text-lg font-bold text-gray-800 dark:text-gray-200 mb-4">
                  Product Quantity Details
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                  {order.products?.map((p, i) => {
                    const rdApproved = p.approvedQuantity?.rAndD || 0;
                    const prodApproved = p.approvedQuantity?.production || 0;

                    const rdRemaining = p.quantity - rdApproved;
                    const prodRemaining = p.quantity - prodApproved;

                    return (
                      <div
                        key={i}
                        className="p-4 bg-white dark:bg-zinc-800 rounded-xl border border-gray-200 dark:border-zinc-700 shadow-sm"
                      >

                        <div className="flex justify-between mb-3">
                          <span className="font-bold text-gray-800 dark:text-gray-200">
                            {p.name}
                          </span>

                          <span className="text-sm font-semibold text-gray-500">
                            Ordered: {p.quantity}
                          </span>
                        </div>

                        <div className="grid grid-cols-2 gap-4 text-sm">

                          <div className="p-3 bg-blue-50 dark:bg-blue-900/30 rounded-lg">
                            <p className="font-semibold text-blue-700 dark:text-blue-300">
                              R&D
                            </p>
                            <p>Approved: <b>{rdApproved}</b></p>
                            <p>Remaining: <b>{rdRemaining}</b></p>
                          </div>

                          <div className="p-3 bg-purple-50 dark:bg-purple-900/30 rounded-lg">
                            <p className="font-semibold text-purple-700 dark:text-purple-300">
                              Production
                            </p>
                            <p>Approved: <b>{prodApproved}</b></p>
                            <p>Remaining: <b>{prodRemaining}</b></p>
                          </div>

                        </div>
                      </div>
                    );
                  })}

                </div>
              </div>

              {/* ================= PROGRESS ================= */}
              <div className="mt-6 p-4 bg-white/60 dark:bg-zinc-800/60 rounded-xl backdrop-blur-sm border border-gray-200 dark:border-zinc-700">

                <p className="text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">
                  Overall Completion Progress
                </p>

                <div className="flex items-center gap-3">
                  <div className="flex-1 h-3 bg-gray-200 dark:bg-zinc-700 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-700 ease-out"
                      style={{ width: `${getProgressPercentage(order)}%` }}
                    />
                  </div>

                  <span className="text-lg font-black text-gray-800 dark:text-gray-200">
                    {getProgressPercentage(order)}%
                  </span>
                </div>

              </div>

            </div>
          ) : null;
        })()}
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <BeatLoader color="#3b82f6" size={15} />
        </div>
      ) : (
        <>
          {/* Desktop Table */}
          <div className="w-full hidden lg:block backdrop-blur-xl bg-white/80 dark:bg-zinc-900/80 rounded-3xl shadow-2xl overflow-hidden border-2 border-gray-200 dark:border-zinc-700">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-slate-200 via-blue-100 to-indigo-200 dark:from-zinc-800 dark:via-blue-950 dark:to-indigo-950">
                <tr>
                  <th className="py-5 px-6 text-left uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Order Number</th>
                  <th className="py-5 px-4 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Generated By</th>
                  <th className="py-5 px-4 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Creation Date</th>
                  <th className="py-5 px-4 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Dispatch Date</th>
                  <th className="py-5 px-4 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Approval Progress</th>
                  <th className="py-5 px-4 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Status</th>
                  <th className="py-5 px-6 text-center uppercase text-xs font-black tracking-wider text-gray-700 dark:text-gray-300">Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map((order: any, index: number) => (
                  <tr
                    key={index}
                    onClick={() =>
                      setSelectedOrder(prev =>
                        prev === order._id ? null : order._id
                      )
                    }
                    className={`border-b border-gray-200 dark:border-zinc-700 cursor-pointer hover:bg-gradient-to-r hover:from-blue-50 hover:via-purple-50 hover:to-pink-50 dark:hover:from-blue-950/30 dark:hover:via-purple-950/30 dark:hover:to-pink-950/30 transition-all duration-300 ${approvingOrders.has(order._id) ? 'animate-swipe-out' : 'animate-fade-in'
                      } ${selectedOrder === order._id ? 'bg-blue-100 dark:bg-blue-900/30 ring-2 ring-blue-400' : ''}`}
                    style={{ animationDelay: `${index * 50}ms` }}
                  >
                    <td className="py-5 px-6 text-left">
                      <span className="text-blue-600 dark:text-blue-400 font-black text-base">{order.orderNumber}</span>
                    </td>
                    <td className="py-5 px-4 text-center">
                      <div className="flex flex-col items-center">
                        <span className="font-bold capitalize text-gray-800 dark:text-gray-200">{order.generatedBy.username}</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">{order.generatedBy.employeeId}</span>
                      </div>
                    </td>
                    <td className="py-5 px-4 text-center font-semibold text-gray-700 dark:text-gray-300">
                      {order.orderDate ? formatDate(order.orderDate) : formatDate(order.createdAt)}
                    </td>
                    <td className="py-5 px-4 text-center font-semibold text-gray-700 dark:text-gray-300">
                      {order.estimatedDispatchDate?.split("T")[0]}
                    </td>
                    <td className="py-5 px-4">
                      <div
                        className="flex flex-col items-center gap-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProgressClick(order);
                        }}
                      >
                        <div className={`w-full max-w-[200px] h-4 bg-gradient-to-r from-gray-300 to-gray-400 dark:from-zinc-700 dark:to-zinc-800 rounded-full overflow-hidden shadow-inner ${canUserApprove(order) ? 'cursor-pointer hover:ring-2 hover:ring-blue-400 transition-all' : 'cursor-default'}`}>
                          <div
                            className={`h-full transition-all duration-700 ease-out ${getProgressPercentage(order) === 100
                              ? 'bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500'
                              : 'bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600'
                              }`}
                            style={{ width: `${getProgressPercentage(order)}%` }}
                          ></div>
                        </div>
                        <div className="flex items-center gap-3 text-xs font-bold">
                          <span className={`px-2 py-1 rounded-full ${order.approval?.rAndD?.approved ? 'bg-green-500 text-white' : 'bg-gray-400 dark:bg-gray-600 text-white'}`}>
                            R&D {order.approval?.rAndD?.approved ? '✓' : '○'}
                          </span>
                          <span className={`px-2 py-1 rounded-full ${order.approval?.production?.approved ? 'bg-green-500 text-white' : 'bg-gray-400 dark:bg-gray-600 text-white'}`}>
                            Prod {order.approval?.production?.approved ? '✓' : '○'}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-5 px-4 text-center">
                      <span
                        className={`inline-block font-bold uppercase text-xs tracking-wider rounded-full px-4 py-2 shadow-lg ${order.status === "completed" && "bg-gradient-to-r from-green-500 to-emerald-600 text-white"
                          } ${order.status === "pending" && "bg-gradient-to-r from-yellow-500 to-amber-600 text-white"
                          } ${order.status === "delayed" && "bg-gradient-to-r from-orange-500 to-red-600 text-white"
                          } ${order.status === "rejected" && "bg-gradient-to-r from-red-600 to-pink-700 text-white"
                          }`}
                      >
                        {order.status}
                      </span>
                    </td>
                    <td className="py-5 px-6 text-right">
                      <div className="flex justify-end items-center gap-3">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewDetails(order);
                          }}
                          className="p-3 rounded-xl hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-all duration-200 group shadow-md hover:shadow-lg"
                        >
                          <IoEyeOutline className="text-2xl text-blue-600 dark:text-blue-400 group-hover:scale-125 transition-transform" />
                        </button>

                        {(isRnD || isProduction) && (
                          <button
                            disabled={
                              !canUserApprove(order) ||
                              order?.approval?.rAndD?.approved && order?.approval?.production?.approved
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!canUserApprove(order)) return;

                              setApproveOrder(order);
                              setApproveModalOpen(true);

                              const initialQty: Record<number, number> = {};

                              order.products?.forEach((p: any, i: number) => {
                                initialQty[i] = 0;
                              });

                              setQuantities(initialQty);
                              setApproveType("all");
                            }}
                            className={`relative overflow-hidden px-6 py-3 rounded-xl font-black text-white
      transition-all duration-300 shadow-lg
      ${approvingOrders.has(order._id)
                                ? "bg-gradient-to-r from-green-500 to-emerald-600 animate-pulse cursor-wait"
                                : canUserApprove(order)
                                  ? "bg-orange-400 shadow-lg hover:scale-105 hover:shadow-blue-500/50 transition-all duration-300 ease-in-out"
                                  : "bg-gradient-to-r from-green-500 to-emerald-600 cursor-default"
                              }`}
                          >
                            <span className="relative z-10 flex items-center gap-2 min-w-[110px] justify-center">
                              {approvingOrders.has(order._id) ? (
                                <>
                                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                    <circle
                                      className="opacity-25"
                                      cx="12"
                                      cy="12"
                                      r="10"
                                      stroke="currentColor"
                                      strokeWidth="4"
                                      fill="none"
                                    />
                                    <path
                                      className="opacity-75"
                                      fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    />
                                  </svg>
                                  Approving...
                                </>
                              ) : canUserApprove(order) ? (
                                "Approve"
                              ) : (
                                "✓ Approved"
                              )}
                            </span>
                          </button>
                        )}

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="w-full flex flex-col gap-4 lg:hidden">
            {filteredOrders.map((order: any, index: number) => (
              <div
                key={order._id}
                onClick={() => setSelectedOrder(order._id)}
                className={`backdrop-blur-xl bg-white/90 dark:bg-zinc-800/90 shadow-2xl rounded-2xl p-6 border-2 border-gray-200 dark:border-zinc-700 hover:shadow-3xl transition-all duration-300 cursor-pointer ${approvingOrders.has(order._id) ? 'animate-swipe-out' : 'animate-fade-in'
                  } ${selectedOrder === order._id ? 'ring-4 ring-blue-400' : ''}`}
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="flex flex-col gap-4">
                  <div className="flex justify-between items-center pb-3 border-b-2 border-gray-200 dark:border-zinc-700">
                    <span className="font-bold text-gray-600 dark:text-gray-400">Order Number</span>
                    <span className="text-blue-600 dark:text-blue-400 font-black text-lg">{order.orderNumber}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-gray-600 dark:text-gray-400">Generated By</span>
                    <div className="text-right">
                      <div className="font-black capitalize text-gray-800 dark:text-gray-200">{order.generatedBy.username}</div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 font-medium">{order.generatedBy.employeeId}</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-gray-600 dark:text-gray-400">Creation Date</span>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                      {order.orderDate ? formatDate(order.orderDate) : formatDate(order.createdAt)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-gray-600 dark:text-gray-400">Dispatch Date</span>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">{order.estimatedDispatchDate?.split("T")[0]}</span>
                  </div>

                  {/* Progress Bar Mobile */}
                  <div
                    className="py-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleProgressClick(order);
                    }}
                  >
                    <p className="text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Approval Progress</p>
                    <div className={`w-full h-4 bg-gradient-to-r from-gray-300 to-gray-400 dark:from-zinc-700 dark:to-zinc-800 rounded-full overflow-hidden shadow-inner mb-2 ${canUserApprove(order) ? 'cursor-pointer' : 'cursor-default'}`}>
                      <div
                        className={`h-full transition-all duration-700 ease-out ${getProgressPercentage(order) === 100
                          ? 'bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500'
                          : 'bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600'
                          }`}
                        style={{ width: `${getProgressPercentage(order)}%` }}
                      ></div>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className={`text-xs px-2 py-1 rounded-full font-bold ${order.approval?.rAndD?.approved ? 'bg-green-500 text-white' : 'bg-gray-400 dark:bg-gray-600 text-white'}`}>
                          R&D {order.approval?.rAndD?.approved ? '✓' : '○'}
                        </span>
                        <span className={`text-xs px-2 py-1 rounded-full font-bold ${order.approval?.production?.approved ? 'bg-green-500 text-white' : 'bg-gray-400 dark:bg-gray-600 text-white'}`}>
                          Prod {order.approval?.production?.approved ? '✓' : '○'}
                        </span>
                      </div>
                      <span className="text-sm font-black text-gray-800 dark:text-gray-200">{getProgressPercentage(order)}%</span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="font-bold text-gray-600 dark:text-gray-400">Status</span>
                    <span
                      className={`font-bold uppercase text-xs tracking-wider rounded-full px-4 py-2 shadow-lg ${order.status === "completed" && "bg-gradient-to-r from-green-500 to-emerald-600 text-white"
                        } ${order.status === "pending" && "bg-gradient-to-r from-yellow-500 to-amber-600 text-white"
                        } ${order.status === "delayed" && "bg-gradient-to-r from-orange-500 to-red-600 text-white"
                        } ${order.status === "rejected" && "bg-gradient-to-r from-red-600 to-pink-700 text-white"
                        }`}
                    >
                      {order.status}
                    </span>
                  </div>
                  <div className="flex justify-end items-center gap-3 pt-3 border-t-2 border-gray-200 dark:border-zinc-700">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewDetails(order);
                      }}
                      className="p-3 rounded-xl hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-all duration-200 shadow-md"
                    >
                      <IoEyeOutline className="text-2xl text-blue-600 dark:text-blue-400" />
                    </button>

                    {(isRnD || isProduction) && (
                      <button
                        disabled={!canUserApprove(order) || approvingOrders.has(order._id)}
                        onClick={(e) => {
                          e.stopPropagation();

                          if (!canUserApprove(order)) return;

                          setApproveOrder(order);
                          setApproveModalOpen(true);

                          const initialQty: Record<number, number> = {};

                          order.products?.forEach((p: any, i: number) => {
                            initialQty[i] = 0;   
                          });

                          setQuantities(initialQty);
                          setApproveType("quantity");

                          setQuantities(initialQty);
                          setApproveType("all");
                        }}
                        className={`relative overflow-hidden px-5 py-2 rounded-xl font-black text-white
      transition-all duration-300 shadow-lg
      ${approvingOrders.has(order._id)
                            ? "bg-gradient-to-r from-green-500 to-emerald-600 animate-pulse cursor-wait"
                            : canUserApprove(order)
                              ? "bg-orange-400 shadow-lg hover:scale-105 hover:shadow-blue-500/50 transition-all duration-300 ease-in-out"
                              : "bg-gradient-to-r from-green-500 to-emerald-600 cursor-default"
                          }`}
                      >
                        <span className="relative z-10 flex items-center gap-2 min-w-[96px] justify-center text-sm">
                          {approvingOrders.has(order._id) ? (
                            <>
                              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                  fill="none"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                />
                              </svg>
                              Approving...
                            </>
                          ) : canUserApprove(order) ? (
                            "Approve"
                          ) : (
                            "✓ Approved"
                          )}
                        </span>
                      </button>
                    )}

                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center gap-3 pb-10 mt-6">
            <button
              onClick={handlePrev}
              disabled={page === 1}
              className="px-6 py-3 bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:from-gray-800 hover:to-gray-900 transition-all duration-300 font-bold shadow-xl disabled:shadow-none"
            >
              Prev
            </button>
            {Array.from({ length: totalPages }, (_, idx) => idx + 1)
              .filter((p) => p === 1 || p === totalPages || (p >= page - 1 && p <= page + 1))
              .map((p, i, arr) => {
                const prevPage = arr[i - 1];
                return (
                  <span key={p} className="flex items-center gap-3">
                    {prevPage && p - prevPage > 1 && <span className="px-2 text-gray-400 font-bold">...</span>}
                    <button
                      onClick={() => handlePageClick(p)}
                      className={`px-5 py-3 rounded-xl font-black transition-all duration-300 ${page === p
                        ? "bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white shadow-2xl scale-110 ring-4 ring-blue-400/50"
                        : "bg-white dark:bg-zinc-800 hover:bg-gray-100 dark:hover:bg-zinc-700 border-2 border-gray-300 dark:border-zinc-600 shadow-lg hover:scale-105"
                        }`}
                    >
                      {p}
                    </button>
                  </span>
                );
              })}
            <button
              onClick={handleNext}
              disabled={page === totalPages}
              className="px-6 py-3 bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:from-gray-800 hover:to-gray-900 transition-all duration-300 font-bold shadow-xl disabled:shadow-none"
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* Enhanced Modal */}
      {viewModalOpen && viewOrder && (
        <div className="fixed inset-0 flex items-center justify-center p-4 bg-black/70 backdrop-blur-md z-50 animate-fade-in">
          <div
            className="backdrop-blur-2xl bg-white/95 dark:bg-zinc-900/95 text-black dark:text-white p-8 rounded-3xl shadow-2xl w-full max-w-5xl overflow-auto max-h-[90vh] border-2 border-gray-300 dark:border-zinc-600 animate-scale-in"
          >
            <div className="flex justify-between items-center mb-6 pb-4 border-b-2 border-gray-300 dark:border-zinc-700">
              <h2 className="text-3xl font-black bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                Purchase Order Details
              </h2>
              <button
                onClick={() => {
                  setViewModalOpen(false);
                  setViewOrder(null);
                }}
                className="text-3xl font-bold px-4 py-2 rounded-xl hover:bg-red-100 dark:hover:bg-red-900/30 text-red-600 dark:text-red-400 transition-all duration-200 hover:scale-110"
                aria-label="Close details"
              >
                ×
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="space-y-3 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-900/30 dark:via-indigo-900/30 dark:to-purple-900/30 p-6 rounded-2xl border-2 border-blue-300 dark:border-blue-700 shadow-lg">
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Order Number:</span>
                  <span className="font-black text-blue-600 dark:text-blue-400 text-lg">{viewOrder.orderNumber}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Generated By:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">{viewOrder.generatedBy?.username}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Employee ID:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">{viewOrder.generatedBy?.employeeId}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Status:</span>
                  <span className="uppercase font-black text-sm">{viewOrder.status}</span>
                </div>
              </div>
              <div className="space-y-3 bg-gradient-to-br from-purple-50 via-pink-50 to-red-50 dark:from-purple-900/30 dark:via-pink-900/30 dark:to-red-900/30 p-6 rounded-2xl border-2 border-purple-300 dark:border-purple-700 shadow-lg">
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Order Date:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">{formatDate(viewOrder.orderDate || viewOrder.createdAt)}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Dispatch Date:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">
                    {viewOrder.estimatedDispatchDate ? viewOrder.estimatedDispatchDate.split("T")[0] : "N/A"}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Contact:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">{viewOrder.contact || "N/A"}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-gray-700 dark:text-gray-300">Company:</span>
                  <span className="font-black text-gray-900 dark:text-gray-100">{viewOrder.companyName || "N/A"}</span>
                </div>
              </div>
            </div>
            {viewOrder.products && viewOrder.products.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg sm:text-xl font-black mb-4 flex items-center gap-3">
                  <span className="w-2 h-6 sm:h-8 bg-gradient-to-b from-blue-500 via-purple-600 to-pink-600 rounded-full"></span>
                  Products
                </h3>

                {/* ================= MOBILE VIEW (CARDS) ================= */}
                <div className="grid grid-cols-1 gap-4 md:hidden">
                  {viewOrder.products.map((p: any, i: number) => (
                    <div
                      key={i}
                      className="rounded-xl border border-gray-300 dark:border-zinc-700 bg-white/70 dark:bg-zinc-800/70 p-4 shadow-lg"
                    >
                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-bold text-gray-500">Name</span>
                        <span className="font-black text-gray-900 dark:text-white text-right">
                          {p.name}
                        </span>
                      </div>

                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-bold text-gray-500">Quantity</span>
                        <span className="font-semibold">{p.quantity}</span>
                      </div>

                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-bold text-gray-500">Price</span>
                        <span className="font-black text-green-600 dark:text-green-400">
                          {p.price}
                        </span>
                      </div>

                      <div className="flex justify-between">
                        <span className="text-sm font-bold text-gray-500">Remark</span>
                        <span className="text-gray-700 dark:text-gray-300 text-right">
                          {p.remark || "-"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ================= DESKTOP VIEW (TABLE) ================= */}
                <div className="hidden md:block backdrop-blur-md bg-white/60 dark:bg-zinc-800/60 border-2 border-gray-300 dark:border-zinc-700 rounded-2xl overflow-hidden shadow-xl">
                  <table className="w-full text-sm">
                    <thead className="bg-gradient-to-r from-slate-200 to-blue-200 dark:from-zinc-700 dark:to-blue-900">
                      <tr>
                        <th className="px-4 py-4 text-center font-black">Name</th>
                        <th className="px-4 py-4 text-center font-black">Quantity</th>
                        <th className="px-4 py-4 text-center font-black">Price</th>
                        <th className="px-4 py-4 text-center font-black">Remark</th>
                      </tr>
                    </thead>

                    <tbody>
                      {viewOrder.products.map((p: any, i: number) => (
                        <tr
                          key={i}
                          className="border-t-2 border-gray-200 dark:border-zinc-700 hover:bg-white/70 dark:hover:bg-zinc-700/70 transition"
                        >
                          <td className="px-4 py-4 font-bold">{p.name}</td>
                          <td className="px-4 py-4 text-center">{p.quantity}</td>
                          <td className="px-4 py-4 text-center font-black text-green-600 dark:text-green-400 text-lg">
                            {p.price}
                          </td>
                          <td className="px-4 py-4 text-gray-600 dark:text-gray-400">
                            {p.remark || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            <div className="flex justify-end mt-8 pt-4 border-t-2 border-gray-300 dark:border-zinc-700">
              <button
                onClick={() => {
                  setViewModalOpen(false);
                  setViewOrder(null);
                }}
                className="px-8 py-4 bg-gradient-to-r from-red-600 via-red-700 to-pink-700 text-white rounded-xl hover:from-red-700 hover:to-pink-800 transition-all duration-300 font-black shadow-2xl shadow-red-500/50 transform hover:scale-105"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {approveModalOpen && approveOrder && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-md z-50 animate-fade-in">
          <div className="bg-white/95 dark:bg-zinc-900/95 backdrop-blur-xl p-8 rounded-3xl shadow-2xl w-full max-w-3xl border border-gray-300 dark:border-zinc-700 animate-scale-in">

            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-black bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                Approve Order {approveOrder.orderNumber}
              </h2>

              <button
                onClick={() => {
                  setApproveModalOpen(false);
                  setApproveOrder(null);
                }}
                className="text-2xl text-red-500 hover:scale-110 transition"
              >
                ×
              </button>
            </div>

            {/* Approval Type */}
            <div className="flex gap-4 mb-6">
              <button
                onClick={() => setApproveType("all")}
                className={`flex-1 py-3 rounded-xl font-bold transition
          ${approveType === "all"
                    ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                    : "bg-gray-200 dark:bg-zinc-700"
                  }`}
              >
                Approve All Remaining
              </button>

              <button
                onClick={() => setApproveType("quantity")}
                className={`flex-1 py-3 rounded-xl font-bold transition
          ${approveType === "quantity"
                    ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white"
                    : "bg-gray-200 dark:bg-zinc-700"
                  }`}
              >
                Quantity Wise
              </button>
            </div>

            {/* Quantity Inputs */}

            {approveType === "quantity" && (
              <div className="space-y-3 max-h-72 overflow-y-auto">

                {approveOrder.products?.map((p: any, i: number) => {

                  const approved = isProduction
                    ? p.approvedQuantity?.production || 0
                    : p.approvedQuantity?.rAndD || 0;

                  const remaining = p.quantity - approved;

                  return (
                    <div
                      key={i}
                      className="flex justify-between items-center p-4 bg-gray-100 dark:bg-zinc-800 rounded-xl"
                    >
                      <div>
                        <p className="font-bold">{p.name}</p>

                        <p className="text-xs text-gray-500">
                          Ordered: {p.quantity} | Approved: {approved} | Remaining: {remaining}
                        </p>
                      </div>

                      <input
                        type="number"
                        min={0}
                        max={remaining}
                        value={quantities[i] ?? 0}
                        onChange={(e) => {
                          const value = Number(e.target.value);

                          if (value > remaining) return;

                          setQuantities({
                            ...quantities,
                            [i]: value,
                          });
                        }}
                        className="w-24 px-3 py-1 rounded-lg border text-center font-bold"
                      />
                    </div>
                  );
                })}
              </div>
            )}

            {/* Approve Button */}

            <div className="flex justify-end mt-8">
              <button
                onClick={confirmApprove}
                className="px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-black rounded-xl hover:scale-105 transition shadow-xl"
              >
                Confirm Approval
              </button>
            </div>

          </div>
        </div>
      )}
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes swipe-out {
          from {
            opacity: 1;
            transform: translateX(0);
          }
          to {
            opacity: 0;
            transform: translateX(100%);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.5s ease-out forwards;
        }

        .animate-scale-in {
          animation: scale-in 0.4s ease-out forwards;
        }

        .animate-slide-down {
          animation: slide-down 0.5s ease-out forwards;
        }

        .animate-swipe-out {
          animation: swipe-out 0.6s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default SubadminApprovePO;